import { context } from '@wikia/ad-engine';

export function getOzoneContext(): object {
	const floorAdhesionConfigs = context.get('experiments.persistentAdhesionExperiment')
		? {}
		: {
				floor_adhesion: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.floor_adhesion ?? [
						[320, 50],
						[320, 100],
					],
					pos: 'OZ_floor_adhesion',
					placementId: '3500013049',
				},
			};

	return {
		enabled: false,
		slots: {
			mobile_top_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.mobile_top_leaderboard ?? [
					[320, 100],
					[320, 50],
				],
				pos: 'OZ_mobile_top_leaderboard',
				placementId: '3500013046',
			},
			top_boxad: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.top_boxad ?? [
					[300, 250],
					[300, 600],
				],
				pos: 'OZ_top_boxad',
				placementId: '3500013044',
			},
			gallery_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.gallery_leaderboard ?? [
					[320, 100],
					[320, 50],
				],
				pos: 'OZ_fandom_mw_galleries',
				placementId: '3500013052',
			},
			incontent_boxad_1: {
				sizes: [[300, 250]],
				pos: 'OZ_incontent_boxad',
				placementId: '3500013048',
			},
			bottom_leaderboard: {
				sizes: [[300, 250]],
				pos: 'OZ_mobile_prefooter',
				placementId: '3500013045',
			},
			...floorAdhesionConfigs,
		},
	};
}
